import { FONT } from '@cuemath/comps';

export const FONT_FAMILY = FONT.FAMILY;
